<dm-modal-wrapper [title]="title" [isShowModal]="_showModal" [buttons]="buttons">
    <div class="row company-selection-container">
        <div class="col-md-12">
            <div class="row grid-tool">
                <div class="col-sm-12">
                    <div class="input-group">
                        <span class="input-group-addon">
                            <i class="glyphicon glyphicon-filter"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            id="listQuickFilterInput"
                            (keyup)="onListQuickFilterChanged($event)"
                            placeholder="Filter companies"
                        />
                    </div>
                </div>
            </div>

            <ag-grid-angular
                [gridOptions]="listGridOptions"
                [columnDefs]="headerNames"
                [rowData]="companiesList"
                class="company-selection-grid"
            ></ag-grid-angular>

            <div *ngIf="isLoading" class="company-selection-overlay">
                <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
            </div>
        </div>
    </div>
</dm-modal-wrapper>

<ng-template #loadingSpinner>
    <div id="loader-inner">
        <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter id="halo-cs" filterUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="2"></feGaussianBlur>
                </filter>
                <filter id="gooey-cs" filterUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
                    <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="3"></feGaussianBlur>
                    <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                    ></feColorMatrix>
                </filter>
            </defs>
            <g filter="url(#gooey-cs)">
                <circle
                    *ngFor="let delay of trailDelays; let i = index"
                    cx="50"
                    cy="20"
                    r="6"
                    class="dot"
                    [style.fill]="getTrailFill(i)"
                    [style.animation-delay.s]="delay"
                ></circle>
            </g>
            <circle
                cx="50"
                cy="20"
                r="6"
                fill="none"
                stroke="white"
                stroke-width="4"
                filter="url(#halo-cs)"
                class="dot"
            ></circle>
            <circle cx="50" cy="20" r="6" fill="var(--primary-color)" class="dot"></circle>
        </svg>
    </div>
</ng-template>
